import { render, staticRenderFns } from "./RequestList.vue?vue&type=template&id=2914dd30&scoped=true&"
import script from "./RequestList.vue?vue&type=script&lang=ts&"
export * from "./RequestList.vue?vue&type=script&lang=ts&"
import style0 from "./RequestList.vue?vue&type=style&index=0&id=2914dd30&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2914dd30",
  null
  
)

export default component.exports